// extracted by mini-css-extract-plugin
export default {"cardContainer":"dream_cardContainer__OyId8","showCard":"dream_showCard__sDM6b","editStyle":"dream_editStyle__rZ7MS","font20":"dream_font20__u1LiR"};